import { typeOfPAF } from "../../../../constants/typeOfPAF";

export function isChangedWeeksPerCycle(form) {
  const checkNewNCycles =
    form?.weeks_per_cycle?.id === 0
      ? form?.n_weeks_other
      : form?.weeks_per_cycle?.id;

  return Boolean(checkNewNCycles);
}

export function checkIfNumberOfWeeksExceeded(form, typeOfForm) {
  const isWOMANOFCP = typeOfForm === typeOfPAF.WOMANOFCP;
  const isMALE = typeOfForm === typeOfPAF.MALE;
  const isWOMANOFNCP = typeOfForm === typeOfPAF.WOMANOFNCP;

  const maxWeeksWCBP = form?.max_weeks_wcbp || form?.max_weeks_wcbp;
  const maxWeeksMOrWNCBP =
    form?.max_weeks_m_or_wncbp || form?.max_weeks_m_or_wncbp;

  const nrCycles = !!form?.number_weeks?.id
    ? form?.number_weeks?.id
    : !!form?.n_weeks_other
      ? form?.n_weeks_other
      : !!form?.other
        ? parseFloat(form?.other)
        : parseFloat(form?.n_weeks);

  return isWOMANOFCP
    ? maxWeeksWCBP && maxWeeksWCBP > 0
      ? nrCycles > maxWeeksWCBP
      : false
    : isMALE || isWOMANOFNCP
      ? maxWeeksMOrWNCBP && maxWeeksMOrWNCBP > 0
        ? nrCycles > maxWeeksMOrWNCBP
        : false
      : false;
}

export function checkIfTotalSupplyWeeksExceeded(form, typeOfForm) {
  const isWOMANOFCP = typeOfForm === typeOfPAF.WOMANOFCP;
  const isMALE = typeOfForm === typeOfPAF.MALE;
  const isWOMANOFNCP = typeOfForm === typeOfPAF.WOMANOFNCP;

  const maxWeeksWCBP = form?.max_weeks_wcbp;
  const maxWeeksMOrWNCBP = form?.max_weeks_m_or_wncbp;

  return isWOMANOFCP
    ? maxWeeksWCBP && maxWeeksWCBP > 0
      ? isChangedWeeksPerCycle(form) && form?.total_weeks_supply > maxWeeksWCBP
      : false
    : isMALE || isWOMANOFNCP
      ? maxWeeksMOrWNCBP && maxWeeksMOrWNCBP > 0
        ? isChangedWeeksPerCycle(form) &&
          form?.total_weeks_supply > maxWeeksMOrWNCBP
        : false
      : false;
}

export function checkIfNumberOfCyclesExceeded(form, typeOfForm) {
  if (typeOfForm === typeOfPAF.MALE || typeOfForm === typeOfPAF.WOMANOFNCP) {
    const getNumberOfCyles = form?.number_cycles?.id;
    return getNumberOfCyles > 3;
  }
  const getNumberOfCyles = form?.number_cycles?.id;
  return getNumberOfCyles > 1;
}
